<div style="margin: 15px 0;">
  <h2>{{ editingReservationId ? 'Edit Reservation' : 'Book Reservation' }}</h2>
  
  <form [formGroup]="reservationForm" (ngSubmit)="onSubmit()" class="form-container">
    <div class="form-group">
      <label for="date" class="form-label">Date:</label>
      <input 
        type="date" 
        id="date" 
        formControlName="date" 
        class="form-control"
        required>
    </div>

    <div class="form-group">
      <label for="startTime" class="form-label">Start Time:</label>
      <select 
        id="startTime" 
        formControlName="startTime" 
        class="form-control"
        required>
        <option value="">-- Select Start Time --</option>
        <option *ngFor="let time of timeSlots" [value]="time.value">
          {{time.display}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="stopTime" class="form-label">Stop Time:</label>
      <select 
        id="stopTime" 
        formControlName="stopTime" 
        class="form-control"
        required>
        <option value="">-- Select Stop Time --</option>
        <option *ngFor="let time of timeSlots" [value]="time.value">
          {{time.display}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="opponentId" class="form-label">Opponent ID:</label>
      <select 
        id="opponentId" 
        formControlName="opponentId" 
        class="form-control"
        required>
        <option value="">-- Select Opponent --</option>
        <option *ngFor="let opponent of opponents" [value]="opponent.value">
          {{opponent.display}}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">Quick Time Selection:</label>
      <div class="shortcut-buttons">
        <button type="button" (click)="setMorningTime()" class="shortcut-button morning">
          8:30 AM - 10:00 AM
        </button>
        <button type="button" (click)="setEveningTime()" class="shortcut-button evening">
          6:30 PM - 8:00 PM
        </button>
      </div>
    </div>

    <div style="margin-top: 30px;">
      <button 
        type="submit" 
        [disabled]="!reservationForm.valid || isSubmitting"
        class="submit-button">
        <span *ngIf="!isSubmitting">{{ editingReservationId ? 'Update Reservation' : 'Book Reservation' }}</span>
        <span *ngIf="isSubmitting">{{ editingReservationId ? 'Updating...' : 'Booking...' }}</span>
      </button>
      
      <button 
        *ngIf="editingReservationId"
        type="button" 
        (click)="cancelEdit()"
        class="cancel-button"
        style="margin-left: 10px;">
        Cancel
      </button>
    </div>

    <div *ngIf="submitMessage" class="submit-message" [class.success]="submitMessage.includes('successfully')" [class.error]="submitMessage.includes('Error')">
      {{submitMessage}}
    </div>
  </form>


  <!-- Reservations List Section -->
  <div class="reservations-section">
    <h3>Current Reservations</h3>
    
    <div *ngIf="isLoadingReservations" class="loading-message">
      Loading reservations...
    </div>

    <div *ngIf="deleteMessage" class="delete-message" [class.success]="deleteMessage.includes('successfully')" [class.error]="deleteMessage.includes('Error')">
      {{deleteMessage}}
    </div>

    <div *ngIf="!isLoadingReservations && reservations.length === 0" class="no-reservations">
      No reservations found.
    </div>

    <div *ngIf="!isLoadingReservations && reservations.length > 0" class="reservations-table-container">
      <table class="reservations-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Opponent</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reservation of reservations">
            <td>{{formatDate(reservation.bookingDate)}}</td>
            <td>{{reservation.startTimeFormatted}} - {{reservation.endTimeFormatted}}</td>
            <td>{{getOpponentName(reservation.user2Id)}}</td>
            <td>
              <span class="status-badge" [class.completed]="reservation.completed" [class.pending]="!reservation.completed">
                {{reservation.completed ? 'Completed' : 'Pending'}}
              </span>
            </td>
            <td>
              <button 
                *ngIf="!reservation.completed"
                type="button" 
                class="edit-button"
                (click)="editReservation(reservation)"
                title="Edit reservation"
                style="margin-right: 8px;">
                Edit
              </button>
              <button 
                *ngIf="!reservation.completed"
                type="button" 
                class="delete-button"
                (click)="deleteReservation(reservation.id)"
                title="Delete reservation">
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
